import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useEventLogging } from '../../../../../../models/Logging';
import { Button } from '../../../../../components-v2/Button';
import { ROUTES } from '../../../../../constants/routes';
import { briefAttendeeSummary, briefMeetingTitle } from '../../../../../pages/MeetingPrepBriefs/helpers';
import { AgentRow, AgentRowIcon } from '../../AgentRow';
import { styleSheet } from '../../styles';
import { MEETING_PREP_TELEMETRY_CATEGORY } from './DashboardMeetingPrepRow';
import { spokenMeetingTime } from './helpers';
import { CalendarIcon } from '@WebComponents/svgs/icons/CalendarIcon';

export const DashboardMeetingPrepLiveRow: FC<{
	nextBrief: Api.IMeetingPrepBrief;
	timeZone: string;
}> = ({ nextBrief, timeZone }) => {
	const history = useHistory();
	const { logEvent } = useEventLogging(MEETING_PREP_TELEMETRY_CATEGORY);

	const goToBrief = (briefId?: string) => {
		logEvent('ViewBriefClicked', { from: 'upcoming' });
		history.push(briefId ? `${ROUTES.meetingPrep.briefs}/${encodeURIComponent(briefId)}` : ROUTES.meetingPrep.briefs);
	};

	return (
		<AgentRow
			icon={
				<AgentRowIcon>
					<CalendarIcon />
				</AgentRowIcon>
			}
			title={
				<>
					{`Your ${spokenMeetingTime(nextBrief, timeZone)} is prepped`}
					<span className={css(styleSheet.rowTitleMeta)}>Meeting Prep Assistant</span>
				</>
			}
			detail={[briefMeetingTitle(nextBrief), briefAttendeeSummary(nextBrief)].filter(Boolean).join(' · ')}
			action={
				<Button size='sm' onClick={() => goToBrief(nextBrief.id)}>
					View brief
				</Button>
			}
		/>
	);
};
